import axios from "axios";

export const BASE_URL = "http://127.0.0.1:8000/api/";

// Create Axios Instance
const axiosInstance = axios.create({
  baseURL: "http://127.0.0.1:8000/api",
});

// Automatically attach access token
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Export properly
export default axiosInstance;
